import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
// import {transformParentEntities} from '@app/utils/helpers';
import {sagaActions as layoutSagaActions} from '@app/modules/layouts/redux/saga';
import {
  createActivityRequest,
  createActivitySuccess,
  createActivityError,
  fetchEntitiesRequest,
  fetchEntitiesSuccess,
  fetchEntitiesError,
  fetchActivityRequest,
  fetchActivitySuccess,
  fetchActivityError,
  updateActivityRequest,
  updateActivitySuccess,
  updateActivityError,
  fetchSourceCategoriesRequest,
  fetchSourceCategoriesSuccess,
  fetchSourceCategoriesError,
  fetchCategorySourcesRequest,
  fetchCategorySourcesSuccess,
  fetchCategorySourcesError,
  fetchSourceDataRequest,
  fetchSourceDataSuccess,
  fetchSourceDataError,
  fetchActivitiesRequest,
  fetchActivitiesSuccess,
  fetchActivitiesError,
} from './index';
import {
  createActivity,
  fetchEntities,
  fetchActivity,
  updateActivity,
  fetchSourceCategories,
  fetchCategorySources,
  fetchSourceData,
  fetchActivities,
} from './api';

export const sagaActions = {
  CREATE_ACTIVITY: 'CREATE_ACTIVITY',
  FETCH_ENTITIES: 'FETCH_ENTITIES',
  FETCH_ACTIVITY: 'FETCH_ACTIVITY',
  UPDATE_ACTIVITY: 'UPDATE_ACTIVITY',
  REMOVE_ACTIVITY: 'REMOVE_ACTIVITY',
  FETCH_SOURCE_CATEGORIES: 'FETCH_SOURCE_CATEGORIES',
  FETCH_CATEGORY_SOURCES: 'FETCH_CATEGORY_SOURCES1',
  FETCH_SOURCE_DATA: 'FETCH_SOURCE_DATA',
  FETCH_ACTIVITIES: 'FETCH_ACTIVITIES',
};

function* createActivitySaga({payload}) {
  const {values, history} = payload;
  try {
    yield put(createActivityRequest());
    const {
      activityYear,
      description,
      parentEntity,
      city1,
      city2,
      sourceCategory,
      emissionSource,
      quantity,
      co2Result,
      totalConsumption,
      ...levelFields
    } = values;
    const result = yield call(createActivity, {
      activityYear: `${activityYear}`,
      activityDesc: description,
      entityId: parentEntity.value,
      city1: city1.value,
      city2: city2.value,
      sourceCategory: sourceCategory.value,
      sourceCategoryName: sourceCategory.label,
      emissionSource: emissionSource.value,
      emissionSourceName: emissionSource.label,
      inputQuantity: quantity,
      totalConsumption,
      co2Result: co2Result.substr(0, co2Result.indexOf('(')),
      level1: levelFields.Level1 ? levelFields.Level1.value : '',
      level2: levelFields.Level2 ? levelFields.Level2.value : '',
      levelFieldsData: JSON.stringify({...levelFields}),
    });
    if (!result.error) {
      toast.success(result.message);
      yield put(createActivitySuccess(result.data));
      history.push(`/activities`);
    } else {
      toast.error(result.error);
      yield put(createActivityError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(createActivityError(message));
    } else {
      toast.error(e.error);
      yield put(createActivityError(e.error));
    }
  }
}

function* fetchEntitiesSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchEntitiesRequest());
    const result = yield call(fetchEntities, values);
    if (!result.error) {
      // const data = yield call(transformParentEntities, result.data);
      yield put(fetchEntitiesSuccess(result.data.data));
    } else {
      yield put(fetchEntitiesSuccess([]));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchEntitiesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchEntitiesError(e.error));
    }
  }
}

function* fetchActivitySaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchActivityRequest());
    const result = yield call(fetchActivity, values);
    if (!result.error) {
      yield put(fetchActivitySuccess(result.data));
    } else {
      toast.error(result.error);
      yield put(fetchActivityError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchActivityError(message));
    } else {
      toast.error(e.error);
      yield put(fetchActivityError(e.error));
    }
  }
}

function* updateActivitySaga({payload}) {
  const {values} = payload;
  try {
    yield put(updateActivityRequest());
    const result = yield call(updateActivity, {
      entityId: values.entityId,
      entityType: values.entityType.value,
      parentEntity: values.parentEntity.value,
      relationToParent: values.relationToParentEntity.value,
      name: values.entityName,
      entityStatus: values.entityStatus.value,
      commercialRegistration: values.commercialRegistration,
      tradingName: values.tradingName,
      address1: values.address1,
      address2: values.address2,
      address3: values.address3,
      city: values.city,
      country: values.country.value,
      postalCode: values.postalCode,
    });
    if (!result.error) {
      toast.success(result.message);
      yield put(updateActivitySuccess(result.data));
      // refresh corporate structure also
      yield put({
        type: layoutSagaActions.FETCH_CORPORATE_STRUCTURE,
        payload: {},
      });
    } else {
      toast.error(result.error);
      yield put(updateActivityError(result.error));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(updateActivityError(message));
    } else {
      toast.error(e.error);
      yield put(updateActivityError(e.error));
    }
  }
}

function* fetchSourceCategoriesSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchSourceCategoriesRequest());
    const result = yield call(fetchSourceCategories, values);
    if (!result.error) {
      // const data = yield call(transformParentEntities, result.data);
      yield put(fetchSourceCategoriesSuccess(result.data.data));
    } else {
      yield put(fetchSourceCategoriesSuccess([]));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchSourceCategoriesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchSourceCategoriesError(e.error));
    }
  }
}

function* fetchCategorySourcesSaga({payload}) {
  const {categoryId, values} = payload;
  try {
    yield put(fetchCategorySourcesRequest());
    const result = yield call(fetchCategorySources, categoryId, values);
    if (!result.error) {
      // const data = yield call(transformParentEntities, result.data);
      yield put(fetchCategorySourcesSuccess(result.data.data));
    } else {
      yield put(fetchCategorySourcesSuccess([]));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchCategorySourcesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchCategorySourcesError(e.error));
    }
  }
}

function* fetchSourceDataSaga({payload}) {
  const {categoryId, sourceId, values} = payload;
  try {
    yield put(fetchSourceDataRequest());
    const result = yield call(fetchSourceData, categoryId, sourceId, values);
    if (!result.error) {
      // const data = yield call(transformSourceData, result.data);
      yield put(fetchSourceDataSuccess(result.data));
    } else {
      yield put(fetchSourceDataSuccess([]));
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchSourceDataError(message));
    } else {
      toast.error(e.error);
      yield put(fetchSourceDataError(e.error));
    }
  }
}

function* fetchActivitiesSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchActivitiesRequest());
    const result = yield call(fetchActivities, values);
    if (!result.error) {
      yield put(
        fetchActivitiesSuccess({
          data: result.data.data,
          page: values.page,
          pageSize: values.pageSize,
          totalPages: result.data.totalPages,
          totalRecords: result.data.totalRecords,
          sortOn: '',
          sortDir: '',
        })
      );
    } else if (result.error) {
      toast.error(result.error);
      yield put(
        fetchActivitiesSuccess({
          data: [],
          page: values.page,
          pageSize: values.pageSize,
          totalPages: 1,
          totalRecords: 0,
          sortOn: '',
          sortDir: '',
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchActivitiesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchActivitiesError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(sagaActions.CREATE_ACTIVITY, createActivitySaga);
  yield takeLatest(sagaActions.FETCH_ENTITIES, fetchEntitiesSaga);
  yield takeLatest(sagaActions.FETCH_ACTIVITY, fetchActivitySaga);
  yield takeLatest(sagaActions.UPDATE_ACTIVITY, updateActivitySaga);
  yield takeLatest(
    sagaActions.FETCH_SOURCE_CATEGORIES,
    fetchSourceCategoriesSaga
  );
  yield takeLatest(
    sagaActions.FETCH_CATEGORY_SOURCES,
    fetchCategorySourcesSaga
  );

  yield takeLatest(sagaActions.FETCH_SOURCE_DATA, fetchSourceDataSaga);
  yield takeLatest(sagaActions.FETCH_ACTIVITIES, fetchActivitiesSaga);
}

export default rootSagas;
